import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import Swal from 'sweetalert2';
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, convertToNumber, handleDateChange, initializeFilterData } from "../CommonComponents/CustomHooks";
import { CommonApiData } from "../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox, InputBox, SelectInputBox } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const PaymentReport = () => {
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const dispatch = useDispatch();
    let [result, setResult] = useState([]);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [loading, setLoading] = useState(false);
    const inputrefs = useRef([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const commonData = CommonApiData();
    let pqrDate = new Date()
    let dateArr = pqrDate?.toString()?.split(' ')
    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`

    let oneMonthAgoDate = new Date(pqrDate);
    oneMonthAgoDate.setMonth(pqrDate.getMonth() - 1);

    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
        "dealerCode": commonData.DealerCode,
    };
    const [formData, setFormData] = useState({
        ...Data,
        "fromDate": dateArr,
        "toDate": dateArr,
        "dealer": Data.dealerCode ? Data.dealerCode : '',
        "mobileNo": "",
        "invoiceNo": "",
        "policyNo": "",
        "paymentStatus": "",
        "productCode": "",
    })

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleClear = () => {
        setFormData({
            ...formData,
            "fromDate": dateArr,
            "toDate": dateArr,
            "mobileNo": "",
            "invoiceNo": "",
            "policyNo": "",
            "paymentStatus": "",
            "productCode": "",
        })
        filterData.SearchText = ''
        filterData.AdvanceFilter = []
        setSortConfig({ SortColumn: null, SortOrder: null })
        inputrefs.current['txtFromDate'].focus()
    }

    let PageName = 'PaymentReport'
    const handleChange1 = (event, value) => {
        GetPaymentReport(value);
    };


    const GetPaymentReport = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...formData,
            ...filterData,
            ...Data,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Report/PaymentReport', GetData)
        setLoading(false)
        if (data.Status === 'SUCCESS') {
            setResult(data)
        }
        else if (data.Status === 'UNAUTHORIZED' || data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.Focus, inputrefs);
        }
        else {
            await NotificationSound(data.Status, data.Message, data.Focus, inputrefs);
        }
        setResult(data)
    }

    const handleReject = async (id) => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/SalesEntryAPI/RefundTransaction', { OnlinePaymentID: id })
        await dispatch(setSubLoading(false))
        if (data.status === 'SUCCESS' || data.status === 'UNAUTHORIZED' || data.status === 'EXPIRED') {
            await NotificationSound(data.status, data.message, '', inputrefs, GetPaymentReport);
        }
    }

    let ExportRequest = {
        ...Data,
        ...formData,
        ...filterData,
        ...sortConfig,
        Type: 'E',
        PageIndex: '1'
    }
    useEffect(() => {
        GetPaymentReport();
        inputrefs.current['txtFromDate'].focus()
        document.title = 'Payment Report'
    }, [sortConfig]);

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{'Payment Report'}</h6>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <DateBox
                            id='txtFromDate'
                            inputrefs={inputrefs}
                            required={true}
                            label='From Date'
                            selected={formData.fromDate === '' ? '' : new Date(formData.fromDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'fromDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtLogDateTo'].focus() };
                            }}

                        />
                        <DateBox
                            id='txtLogDateTo'
                            inputrefs={inputrefs}
                            required={true}
                            label='To Date'
                            selected={formData.toDate === '' ? '' : new Date(formData.toDate)}
                            onChange={(e) => handleDateChange(e, setFormData, formData, 'toDate')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    Data.dealerCode ?
                                        inputrefs.current['txtProductCode'].focus() :
                                        inputrefs.current['txtDealer'].focus();
                                };
                            }}
                        />
                        <AutoCompleteBoxNew
                            id="txtDealer"
                            placeholder="Dealer"
                            label={'Dealer'}
                            inputrefs={inputrefs}
                            disabled={Data.userCode && Data.dealerCode !== "" ? true : false}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtProductCode'].focus()
                                }
                            }}
                            autocompleteType='GetDealerMaster'
                            value={formData.dealer || ''}
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || ''
                                if (event.type !== 'keydown') {
                                    setFormData({ ...formData, dealer: newInputValue })
                                }
                            }}
                            maxLength='50'
                        />

                        <AutoCompleteBoxNew
                            id="txtProductCode"
                            placeholder="Product Code"
                            label={'Product Code'}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtMobileNo'].focus()
                                }
                            }}
                            autocompleteType='GetProductCode'
                            value={formData.productCode || ''}
                            onChange={async (event, newInputValue) => {
                                newInputValue = newInputValue || ''
                                if (event.type !== 'keydown') {
                                    setFormData({ ...formData, productCode: newInputValue })
                                }
                            }}
                            maxLength='50'
                        />
                        <InputBox
                            id="txtMobileNo"
                            placeholder="Mobile No"
                            label='Mobile No'
                            maxLength='10'
                            value={formData.mobileNo}
                            onChange={(e) => setFormData({ ...formData, mobileNo: convertToNumber(e.target.value) })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtInvoiceNo'].focus();
                                }
                            }}
                        />
                        <InputBox
                            id="txtInvoiceNo"
                            placeholder="Invoice No"
                            label='Invoice No'
                            maxLength='30'
                            value={formData.invoiceNo}
                            onChange={(e) => setFormData({ ...formData, invoiceNo: convertToNumber(e.target.value) })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtPolicyNo'].focus();
                                }
                            }}
                        />
                        <InputBox
                            id="txtPolicyNo"
                            placeholder="Policy No"
                            label='Policy No'
                            maxLength='30'
                            value={formData.policyNo}
                            onChange={(e) => setFormData({ ...formData, policyNo: (e.target.value) })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtPaymentStatus'].focus();
                                }
                            }}
                        />
                        <SelectInputBox
                            id="txtPaymentStatus"
                            label='Payment Status'
                            value={formData.paymentStatus}
                            onChange={(e) => setFormData({ ...formData, paymentStatus: (e.target.value) })}
                            inputrefs={inputrefs}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtbtn'].focus();
                                }
                            }}
                        >
                            <option value=''>--Please Select--</option>
                            <option key="SUCCESS" value="SUCCESS">SUCCESS</option>
                            <option key="Pending" value="Pending">Pending</option>
                            <option key="Failed" value="Failed">Failed</option>
                        </SelectInputBox>
                    </div>
                    <div className='d-block mt-3 d-md-flex' >
                        <button
                            ref={ref => (inputrefs.current[`txtbtn`] = ref)}
                            onClick={GetPaymentReport}
                            className="btn btn-rounded btn-primary">
                            <span className=" text-white me-2">
                                <i className="fa fa-search"></i>
                            </span>Search</button>
                        <button
                            className="btn btn-rounded btn-warning"
                            onClick={async () => {
                                try {
                                    dispatch(setSubLoading(true))
                                    await handleDownloadExcel('/api/Report/PaymentReport', ExportRequest, 'Payment Report');
                                    dispatch(setSubLoading(false))

                                } finally {
                                    dispatch(setSubLoading(false))
                                }
                            }}
                        >
                            <span className="text-warning me-2">
                                <i className="fa fa-download text-white color-success"></i>
                            </span>
                            Export
                        </button>
                        <button onClick={handleClear} className="btn btn-rounded btn-danger"><span className="text-white me-2"><i className="fa-solid fa-arrow-rotate-left"></i>
                        </span>Reset</button>
                    </div>
                </div>
            </div>
            <Table
                PageName={PageName}
                loading={loading}
                handleFilter={() => {
                    GetPaymentReport()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                setFilterData={setFilterData}
                handleReject={
                    (e) => {
                        Swal.fire({
                            title: "Are you sure?",
                            text: "Do you want to Refund this Amount?",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Yes",
                            keydownListenerCapture: true,
                            stopKeydownPropagation: false,
                            didOpen: () => {
                                document.addEventListener('keydown', function (event) {
                                    if (event.key === 'Y' || event.key === 'y') {
                                        Swal.clickConfirm();
                                    } else if (event.key === 'N' || event.key === 'n') {
                                        Swal.clickCancel();
                                    }
                                });
                            }
                        }).then(async (result) => {
                            if (result.isConfirmed) {
                                handleReject(e)
                            }
                        })
                    }}
                tableData={result}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
                Filter={false}
                onlyFilterPage={true}
            />
        </>
    )
}
export default PaymentReport;